import { styled } from '@/styles/theme'

export const BaseBox = styled('div', {
  backgroundColor: '$white',
  borderRadius: '$sm',
  border: 'transparent',
})
